import "./TimeOut.scss";
import React, { memo, useContext, useEffect, useState } from "react";
import moment from "moment-timezone";
import { Context } from "../../App";
import Utils from "../../utils/Utils";
import { GET_SERVER_TIME } from "../../services/RequestDatas";
import RequestManager from "../../services/RequestManager";

function TimeOut({
  turnTheWheelCallback,
  wheelTurnedOn,
  isClassicMode,
  setMarketIsClosed,
  marketIsClosed,
}) {
  const params = Utils.getURLParams();
  const context = useContext(Context);
  const gamesData = context.gamesData.get;
  const timeShift = params.timeShift;
  const [startTimestampServer, setStartTimestampServer] = useState();
  const [isTimeLittle, setIsTimeLittle] = useState(false);
  const [remainingTime, setRemainingTime] = useState();
  const [currentTimeServer, setCurrentTimeServer] = useState();
  const beckImg = process.env.PUBLIC_URL + `./assets/wheel_deluxe/time.png?1`;
  const socket = RequestManager.getInstance().webSocket;

  useEffect(() => {
    if (context.gamesData.get) {
      initTimeOut();
      getCurrentTime();
    }
  }, [context.gamesData.get]);

  const updateCountDown = (m, s) => {
    let time = m * 60 + s;
    let refreshIntervalId = setInterval(updateTime, 1000);

    function updateTime() {
      const minutes = Math.floor(time / 60);
      let seconds = time % 60;
      let remainingTime = `${minutes < 10 ? "0" : ""}${minutes}:${
        seconds < 10 ? "0" : ""
      }${seconds}`;

      setRemainingTime(remainingTime);
      time--;

      if (remainingTime[0] === "0") {
        if (remainingTime === "00:20") {
          setIsTimeLittle(true);
        }

        if (remainingTime === "00:10") {
          setMarketIsClosed(true);
        }

        if (remainingTime === "00:00") {
          turnTheWheelCallback();
          setRemainingTime("");
        }
      }

      if (time < 0) {
        clearInterval(refreshIntervalId);
      }
    }
  };

  
  const getCurrentTime = () => {
    socket.send(JSON.stringify(GET_SERVER_TIME));
    socket.addEventListener(
      RequestManager.GET_SERVER_TIME_EVENT,
      parseGameTimesData,
      { once: true }
      );
    };

    const parseGameTimesData = ({ detail }) => {
      setCurrentTimeServer(detail.data.details);
    };
    
  useEffect(() => {
    if (currentTimeServer) {
      updateRemainingTime();
    }
  }, [currentTimeServer]);

  const initTimeOut = () => {
    if (gamesData && Utils.lastKey(gamesData)) {
      setStartTimestampServer(gamesData[Utils.lastKey(gamesData)]["start_ts"]);
    }
  };

  const updateRemainingTime = () => {
    if (startTimestampServer && currentTimeServer) {
      const currentTime = moment.unix(currentTimeServer).format("HH:mm:ss");
      const startTime = moment.unix(startTimestampServer).format("HH:mm:ss");
      const remainingTime = Utils.getTimesDifference(
        startTime,
        currentTime
      ).split(":");

      if (startTime > currentTime) {
        updateCountDown(Number(remainingTime[0]), Number(remainingTime[1]));
      }
    }
  };

  const getLineStyles = () => {
    const seconds =
      parseInt(remainingTime.slice(-2)) + parseInt(remainingTime[1]) * 60;
    const width = (seconds * 100) / timeShift;

    return (
      <div
        className={`timeout-line ${isTimeLittle ? "timeIsLittle" : ""}`}
        style={{
          width: `${width}%`,
          backgroundImage: !isClassicMode
            ? `url(${beckImg})`
            : isTimeLittle
            ? ""
            : "linear-gradient(#EDB13F, #F6C64A, #FDF07E)",
        }}
      />
    );
  };

  return remainingTime && !wheelTurnedOn ? (
    <div className={`timeout-block ${marketIsClosed ? "marketIsClosed" : ""}`}>
      <div
        className={`timeout-time ${
          isClassicMode && !isTimeLittle ? "classic" : "dlx"
        } ${isTimeLittle ? "timeIsLittle" : ""}`}
      >
        {remainingTime}
      </div>
      <div className="timeout-background">{getLineStyles()}</div>
    </div>
  ) : null;
}

export default memo(TimeOut);
